import uuidv4 from "uuid/v4";

import {
  requestResponse as requestResponseMutation,
  createPropertyEvent,
} from "./appsyncOperations";
import * as actions from "../store/actions";
import store from "../store";

const requestResponse = async ({ property, appUser, navigate }) => {
  const { propertyId } = property;
  try {
    const newProperty = await requestResponseMutation({
      propertyId,
      senderId: appUser.userId,
      senderName: appUser.displayName,
      serviceProviderId: appUser.serviceProviderId,
    });
    navigate(newProperty);
    const event = await createPropertyEvent({
      eventId: uuidv4(),
      icon: "APP",
      text: `Response requested by ${appUser.displayName}`,
      senderName: "Kirs",
      senderId: "KIRS",
      propertyId,
      serviceProviderId: appUser.serviceProviderId,
      instanceId: newProperty.instanceId,
    });
    store.dispatch(actions.properties.setProperty(newProperty));
    store.dispatch(actions.properties.setPropertyEvent(event));
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export default requestResponse;
